import { RHFControl, RHFPhoneInput, RHFSelect } from 'components/common/form';
import { Card, Col, Container, Row } from 'react-bootstrap';
import PropTypes from 'prop-types';

const statusOptions = [
  { label: 'Alive', value: 'Alive' },
  { label: 'Deceased', value: 'Deceased' },
  { label: 'Unknown', value: 'Unknown' }
];

const incomeOptions = [
  { label: 'No Income', value: 'No Income' },
  { label: 'Under $100', value: 'Under $100' },
  { label: '$100 - $250', value: '$100 - $250' },
  { label: '$250 - $500', value: '$250 - $500' },
  { label: '$500 - $1000', value: '$500 - $1000' },
  { label: '$1000 - $2000', value: '$1000 - $2000' },
  { label: 'Above $2000', value: 'Above $2000' }
];

const ParentBlock = ({ prefix, title, locationCountry }) => (
  <>
    <h6 className="mt-3 mb-2">{title}</h6>
    <Row className="gx-3">
      <Col xs={12} sm={6} md={4}>
        <RHFControl name={`${prefix}.first_name`} label="First Name" />
      </Col>
      <Col xs={12} sm={6} md={4}>
        <RHFControl name={`${prefix}.middle_name`} label="Middle Name" />
      </Col>
      <Col xs={12} sm={6} md={4}>
        <RHFControl name={`${prefix}.last_name`} label="Last Name" />
      </Col>
    </Row>
    <Row className="gx-3 mt-2">
      <Col xs={12} sm={6} md={4}>
        <RHFSelect
          name={`${prefix}.status`}
          label="Status"
          options={statusOptions}
        />
      </Col>
      <Col xs={12} sm={6} md={4}>
        <RHFPhoneInput
          name={`${prefix}.phone`}
          label="Contact Number"
          defaultCountry={locationCountry}
        />
      </Col>
      <Col xs={12} sm={6} md={4}>
        <RHFControl name={`${prefix}.email`} label="Contact Email" />
      </Col>
    </Row>
    <Row className="gx-3 mt-2">
      <Col xs={12} sm={6}>
        <RHFControl name={`${prefix}.occupation`} label="Occupation" />
      </Col>
      <Col xs={12} sm={6}>
        <RHFSelect
          name={`${prefix}.monthly_income_range`}
          label="Monthly Income Range"
          options={incomeOptions}
        />
      </Col>
    </Row>
    <Row className="mt-2">
      <Col>
        <RHFControl
          name={`${prefix}.address`}
          as="textarea"
          rows={2}
          label="Address"
        />
      </Col>
    </Row>
  </>
);

ParentBlock.propTypes = {
  prefix: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  locationCountry: PropTypes.string
};

export const ParentsDetails = ({
  sectionRef,
  sideNavLink,
  locationCountry
}) => {
  return (
    <Card className="border shadow-none mb-3" ref={sectionRef} id={sideNavLink}>
      <Card.Header className="pb-0">
        <div className="dFlexRowStartSpace pt-3">
          <Card.Title as="h5">Parents</Card.Title>
        </div>
      </Card.Header>
      <Card.Body>
        <Container className="p-0 d-flex flex-column g-3">
          <ParentBlock
            prefix="parents.father"
            title="Father"
            locationCountry={locationCountry}
          />
          <hr className="mt-4" />
          <ParentBlock
            prefix="parents.mother"
            title="Mother"
            locationCountry={locationCountry}
          />
        </Container>
      </Card.Body>
    </Card>
  );
};

ParentsDetails.propTypes = {
  sectionRef: PropTypes.object,
  sideNavLink: PropTypes.string,
  locationCountry: PropTypes.string
};
